import { motion } from 'framer-motion';
import { Calendar, ArrowRight } from 'lucide-react';

export default function DashboardBooking({ bookingUrl, navigate }) {
  return (
    <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.16 }} className="mb-4">
      {bookingUrl ? (
        <div
          className="p-4 rounded-sm flex items-center gap-3"
          style={{ backgroundColor: '#F7F4EF', border: '1px solid #D4C9B8' }}
          data-testid="booking-cta-active"
        >
          <div className="w-10 h-10 rounded-none flex items-center justify-center flex-shrink-0" style={{ backgroundColor: '#B8985A10' }}>
            <Calendar size={18} strokeWidth={1.5} style={{ color: '#B8985A' }} />
          </div>
          <div className="flex-1">
            <span className="text-[13px] font-medium block" style={{ color: '#3C3226' }}>Booking widget is live</span>
            <span className="text-[11px]" style={{ color: '#8C7E6E' }}>Clients can book directly from your public profile</span>
          </div>
          <a
            href={bookingUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="text-[11px] font-medium px-3 py-1.5"
            style={{ color: '#1D6B4F', backgroundColor: '#1D6B4F10' }}
            data-testid="booking-cta-link"
          >
            View
          </a>
        </div>
      ) : (
        <button
          onClick={() => navigate('/profile')}
          className="w-full p-4 rounded-sm flex items-center gap-3 text-left transition-opacity hover:opacity-90"
          style={{ backgroundColor: '#F7F4EF', border: '1px solid #D4C9B8' }}
          data-testid="booking-cta-setup"
        >
          <div className="w-10 h-10 rounded-none flex items-center justify-center flex-shrink-0" style={{ backgroundColor: '#B8985A10' }}>
            <Calendar size={18} strokeWidth={1.5} style={{ color: '#B8985A' }} />
          </div>
          <div className="flex-1">
            <span className="text-[13px] font-medium block" style={{ color: '#3C3226' }}>Accept bookings</span>
            <span className="text-[11px]" style={{ color: '#8C7E6E' }}>Add your Calendly or Cal.com link in Profile settings</span>
          </div>
          <ArrowRight size={16} style={{ color: '#8C7E6E' }} />
        </button>
      )}
    </motion.div>
  );
}
